import { http } from "./http";

export type SentryConfig = {
    dsn: string | null;
    release: string | null;
    environment: string | null;
    debug: boolean;
};

export const sentryApi = {
    async config(): Promise<SentryConfig> {
        const { data } = await http.get<SentryConfig>("/api/v0/sentry");
        return data;
    },
};
